import { Action, Module, Mutation,
  VuexModule } from 'vuex-module-decorators';
import { page } from '@/services/api';


const SET_MAIN_PAGE_TRANSLATION = 'SET_MAIN_PAGE_TRANSLATION';

const rawError: boolean = true;

interface IPage {
  title: string;
  bannerSearchPanel: {
    image: {};
  };
  banner: {};
  bannerTitle: {};
  slides: {
    titleBlock: '',
    items: [],
  };
  list2x2: {};
  single_room_apartments: [];
  informationCard: {};
  actionCard: {};
  bannerMiddle: {};
}
interface IMainPage {
  translation: IPage;
  fetchTranslation: () => any;
}
@Module({namespaced: true})
export default class MainPage extends VuexModule implements IMainPage {
  public translation: IPage = {
    title: '',
    bannerSearchPanel: {
      image: {},
    },
    banner: {},
    bannerTitle: {},
    slides: {
      titleBlock: '',
      items: [],
    },
    list2x2: [],
    single_room_apartments: [],
    informationCard: {},
    actionCard: {},
    bannerMiddle: {},
};

  @Mutation
  public [SET_MAIN_PAGE_TRANSLATION](payload: IPage): void {
    this.translation = payload;
  }

  public get translations(): {} {
    return this.translation;
  }

  public get bannerMiddle(): {} {
    return this.translation.bannerMiddle;
  }

  public get bannerSearchPanel(): {} {
    return this.translation.bannerSearchPanel;
  }

  public get banner(): {} {
    return this.translation.banner;
  }

  public get bannerTitle(): {} {
    return this.translation.bannerTitle;
  }

  public get slides(): {} {
    return this.translation.slides;
  }

  public get list2x2(): {} {
    return this.translation.list2x2;
  }

  public get oneRoomFlats(): {} {
    return this.translation.single_room_apartments;
  }

  public get informationCard(): {} {
    return this.translation.informationCard;
  }

  public get actionCard(): {} {
    return this.translation.actionCard;
  }

  @Action({commit: SET_MAIN_PAGE_TRANSLATION, rawError})
  public async fetchTranslation() {
    const response = await page('main');
    return !response ? this.translation : response;
  }
}
